import axios from 'axios';
import { AddedPersonModel } from 'app/edozvola/cases/added-person/model/added-person.model';

export const fetchAddedPeople = async (idCase: string, page: number, size: number, column: string, direction: string): Promise<any> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios
        .get(`api/added-person/find-all/${ idCase }?page=${ page }&size=${ size }&column=${ column }&direction=${ direction }`)
        .then(response => resolve(response.data));
    });
  }
};

export const deleteAddedPerson = async (idAddedPerson: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/added-person/${ idAddedPerson }`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getAddedPerson = async (idAddedPerson: string): Promise<AddedPersonModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/added-person/${ idAddedPerson }`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const saveAddedPerson = async (idCase: string, addedPerson: AddedPersonModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/added-person/${ idCase }`, addedPerson)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};
